<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-black/70 flex items-center justify-center z-[60] p-4"
    @click.self="close"
  >
    <div class="bg-gray-900 rounded-lg overflow-hidden w-full max-w-[800px] shadow-xl">
      <div class="flex items-center justify-between gap-3 px-4 py-2 bg-gray-800 text-white text-sm">
        <span class="truncate">{{ title || $t('smm.media.video') }}</span>
        <button
          type="button"
          class="shrink-0 w-8 h-8 rounded-full hover:bg-gray-700 text-lg leading-none"
          @click="close"
        >
          ×
        </button>
      </div>
      <video
        ref="player"
        :src="src"
        controls
        autoplay
        playsinline
        class="block w-full h-[600px] max-h-[80vh] bg-black object-contain"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: false },
    src: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  emits: ['close'],
  watch: {
    show(value) {
      if (!value) {
        this.pause()
      }
    },
  },
  methods: {
    close() {
      this.pause()
      this.$emit('close')
    },
    pause() {
      const el = this.$refs.player
      if (el) {
        el.pause()
        el.currentTime = 0
      }
    },
  },
}
</script>
